import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=167f52aa&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('167f52aa')) {
      api.createRecord('167f52aa', component.options)
    } else {
      api.reload('167f52aa', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=167f52aa&", function () {
      api.rerender('167f52aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2I1iWLw9P1ob4/JS/comp/ImgFallback.vue"
export default component.exports